import takeRight from 'lodash/takeRight';
import React from 'react';
import { Link } from 'react-router-dom';
import { getCompletedIconSrc, getExerciseIconSrc } from '../../assets';
import { ExerciseBaseRoute } from '../../exercise/Exercise';
import ProgressGraph, { IProgressEntry } from '../progress/ProgressGraph';
import { MAXIMUM_HIGHSCORE_LENGTH } from './constants';
import './HighscoreCard.scss';

export interface IHighscoreCardProps {
  id?: string;
  title: string;
  className?: string;
  subtitle?: any;
  locale: string | undefined;
  noDataLabel: React.ReactNode;
  progress?: IProgressEntry[];
  scoreRecord?: number;
  exerciseId?: string;
  locked: boolean;
}

export default function HighscoreCard({
  id,
  title,
  className = '',
  subtitle = null,
  locale,
  progress,
  noDataLabel,
  scoreRecord,
  exerciseId,
  locked,
}: Readonly<IHighscoreCardProps>) {
  const iconSrc = exerciseId ? getExerciseIconSrc(exerciseId, false, locked) : getCompletedIconSrc();
  progress = takeRight(progress, MAXIMUM_HIGHSCORE_LENGTH);

  const exerciseLink = !exerciseId ? '' : `${ExerciseBaseRoute}/${exerciseId.toLowerCase()}`;

  return (
    <div className={`highscore-card ${className}`} id={id}>
      <Link
        data-testid="highscore-card"
        to={{
          pathname: exerciseLink,
        }}>
        <div className="highscore-card-icon-wrapper">
          <img className="highscore-card-icon" src={iconSrc} alt={title} />
        </div>
        <div className="highscore-card-wrapper">
          <h3 className="highscore-card-title">{title}</h3>
          <ProgressGraph
            locale={locale}
            noDataLabel={noDataLabel}
            progress={progress}
            useNormalizedScore={false}
            useDynamicWidth={false}
            widthPercent={100 / MAXIMUM_HIGHSCORE_LENGTH}
            showUnderlabel={true}
            scoreRecord={scoreRecord}
          />
          <div className="highscore-card-subtitle">{subtitle}</div>
        </div>
      </Link>
    </div>
  );
}
